var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPhoto = function SvgPhoto(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 21 20",
    fill: "#1E1E1E",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.242.917c-.363 0-.7.18-.902.482L5.88 3.592H3.783A2.872 2.872 0 0 0 .917 6.458v9.809a2.867 2.867 0 0 0 2.866 2.866H18.05a2.867 2.867 0 0 0 2.867-2.866V6.458a2.867 2.867 0 0 0-2.867-2.866h-2.095l-1.462-2.193c-.2-.301-.54-.482-.901-.482h-5.35ZM7.36 5.276 8.82 3.083h4.19l1.463 2.193c.2.301.539.482.901.482h2.675a.7.7 0 0 1 .7.7v9.809a.7.7 0 0 1-.7.7H3.783a.7.7 0 0 1-.7-.7V6.458c0-.382.318-.7.7-.7h2.675c.363 0 .7-.18.902-.482Zm1.073 5.64a2.483 2.483 0 1 1 4.967 0 2.483 2.483 0 0 1-4.967 0Zm2.484-4.65a4.65 4.65 0 1 0 0 9.3 4.65 4.65 0 0 0 0-9.3Z",
    fill: "inherit"
  })));
};
export default SvgPhoto;